import React from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from "./screens/Login";
import Dashboard from "./screens/Dashbord/Dashbord";
import NavbarMenu from "./components/NavbarMenu";
import MyProfile from "./screens/UIElements/MyProfile";
import MySettings from "./screens/UIElements/MySettings";
import MyAlerts from "./screens/UIElements/MyAlerts";
import MyMaps from "./screens/UIElements/MyMaps";
import MRStatus from "./screens/UIElements/MRStatus";
import Controls from "./screens/UIElements/Controls";
import ElevatorStatus from "./screens/UIElements/ElevatorStatus";
import Registration from "./screens/Auth/Registration";
import ForgotPassword from "./screens/Auth/ForgotPassword";
import EmailConfirm from "./screens/Auth/EmailConfirm";
import Page404 from "./screens/Auth/Page404";
import Page403 from "./screens/Auth/Page403";
import Page500 from "./screens/Auth/Page500";
import Page503 from "./screens/Auth/Page503";

window.__DEV__ = true;

export default class App extends React.Component {
  constructor(props) {
    console.warn = () => {}
    super(props);
    this.state = {
      isLoad: true,
    };
  }
  render() {

    var res = window.location.pathname;
    var baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res;

    return (
      <div id="wrapper">
      {activeKey1 === "" ||
        activeKey1 === "/" ||
        activeKey1 === "login" ||
        activeKey1 === "registration" ||
        activeKey1 === "emailConfirm" ||
        activeKey1 === "forgotpassword" ||
        activeKey1 === "page404" ||
        activeKey1 === "page403" ||
        activeKey1 === "page500" ||
        activeKey1 === "page503" ? (
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="login" element={<Login />} />
            <Route path="emailConfirm/:token" element={<EmailConfirm />} />
            <Route exact path="forgotpassword" element={<ForgotPassword />} />
            <Route exact path="page404" element={<Page404 />} />
            <Route exact path="page403" element={<Page403 />} />
            <Route exact path="page500" element={<Page500 />} />
            <Route exact path="page503" element={<Page503 />} />
            <Route exact path="registration" element={<Registration />} />
          </Routes>
          ) : (
            <>
        <NavbarMenu history={this.props.history} activeKey={activeKey1} />
        <div id="main-content">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/mrstatus" element={<MRStatus />} />
            <Route path="/controls" element={<Controls />} />
            <Route path="/elevatorstatus" element={<ElevatorStatus />} />
            <Route path="/myprofilepage" element={<MyProfile />} />
            <Route path="/mysettingspage" element={<MySettings />} />
            <Route path="/myalertspage" element={<MyAlerts />} />
            <Route path="/mymapspage" element={<MyMaps />} />
          </Routes>
        </div>
        </>
          )}
      </div>
    );
  }
}
